import React, { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import { Box, Title, Container, Paper, Group, Card, Text, Stack, Image } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import ParkingSlot from '../../image/parking-slot.svg';
import PrimaryButton from '../../components/GroupButton';
import { sendRequest } from '../../services/services';
import Plate from '../../image/plate.svg';

const Home = () => {
  const { t } = useTranslation();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const passIdData = searchParams.get('passId');
  const passTicketId = searchParams.get('passTicketId');

  const [, setTicketData] = useState();

  useEffect(() => {
    sendRequest(`parking/reservations-by-pass-id/${passTicketId || passIdData}`, 'get').then(
      (res) => {
        setTicketData(res?.data || []);
      },
    );
  }, [passIdData, passTicketId]);

  const [, setMounted] = useState(false);
  const [, setLocation] = useState('');

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);

  return (
    <Box style={{ height: 'calc(100vh - 24px)', marginTop: '24px' }}>
      <Stack justify="space-between" style={{ height: '100%' }}>
        <Box>
          <Container
            className="home"
            style={{
              display: 'flex',
              alignItems: 'stretch',
              flexDirection: 'column',
            }}
          >
            <PrimaryButton />
          </Container>
        </Box>

        <Box style={{ flexGrow: '1' }}>
          <Container
            className="home"
            style={{
              display: 'flex',
              alignItems: 'stretch',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <Box
              className="no-printme"
              style={{
                height: 'fit-content',
                marginBottom: '24px',
                display: 'flex',
                flexDirection: 'column',
                flex: '1',
                justifyContent: 'space-between',
              }}
            >
              <Stack>
                <Title style={{ color: '#2C5864', margin: '1% 0' }} order={3}>
                  {t('find.my.car.title.text')}
                </Title>
              </Stack>
              <Paper shadow="sm" p="lg" radius="lg" style={{ flex: '1' }}>
                <Group style={{ width: '100%', height: '100%' }} grow>
                  <Stack justify="space-around" style={{ width: '100%', height: '100%' }}>
                    <div>
                      <Image src={Plate} width={120} style={{ marginBottom: '8px' }} />
                      <Card
                        shadow="none"
                        radius="sm"
                        p="lg"
                        style={{
                          width: '100%',
                          marginTop: '3px',
                          borderStartStartRadius: '24px',
                          borderStartEndRadius: '24px',
                          backgroundColor: '#F6F6F6',
                        }}
                      >
                        <Group position="apart" grow>
                          <Text size="md" style={{ lineHeight: 1.5 }}>
                            {t('find.my.car.floor.text')}
                          </Text>
                          <Text size="md" style={{ lineHeight: 1.5, textAlign: 'end' }}>
                            3rd
                          </Text>
                        </Group>
                      </Card>
                      <Card
                        shadow="none"
                        radius="sm"
                        p="lg"
                        style={{ width: '100%', marginTop: '3px', backgroundColor: '#F6F6F6' }}
                      >
                        <Group position="apart" grow>
                          <Text size="md" style={{ lineHeight: 1.5 }}>
                            {t('find.my.car.slot.text')}{' '}
                          </Text>
                          <Text size="md" style={{ lineHeight: 1.5, textAlign: 'end' }}>
                            25
                          </Text>
                        </Group>
                      </Card>
                      <Card
                        shadow="none"
                        radius="sm"
                        p="lg"
                        style={{ width: '100%', marginTop: '3px', backgroundColor: '#F6F6F6' }}
                      >
                        <Group position="apart" grow>
                          <Text size="md" style={{ lineHeight: 1.5 }}>
                            {t('find.my.car.gate.text')}
                          </Text>
                          <Text size="md" style={{ lineHeight: 1.5, textAlign: 'end' }}>
                            2A
                          </Text>
                        </Group>
                      </Card>
                      <Card
                        shadow="none"
                        radius="sm"
                        p="lg"
                        style={{
                          width: '100%',
                          marginTop: '3px',
                          borderEndEndRadius: '24px',
                          borderEndStartRadius: '24px',
                          backgroundColor: '#F6F6F6',
                        }}
                      >
                        <Group position="apart" grow>
                          <Text size="md" style={{ lineHeight: 1.5 }}>
                            {t('find.my.car.color.text')}
                          </Text>
                          <Text size="md" style={{ lineHeight: 1.5, textAlign: 'end' }}>
                            Yellow
                          </Text>
                        </Group>
                      </Card>
                    </div>
                  </Stack>
                  <Stack justify="center" style={{ width: '100%', height: '100%' }}>
                    <div>
                      <Image src={ParkingSlot} width="50%" />
                    </div>
                  </Stack>
                </Group>
              </Paper>
            </Box>
          </Container>
        </Box>
      </Stack>
    </Box>
  );
};

export default Home;
